var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSparkles = function SvgIconSparkles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 29,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC164",
    d: "M10.205 24.791s0-12.055 8.902-12.055c-8.902 0-8.902-12.054-8.902-12.054s0 12.054-8.902 12.054c8.902 0 8.902 12.055 8.902 12.055M21.489 28.5s0-7.163 5.209-7.163c-5.21 0-5.21-7.163-5.21-7.163s0 7.163-5.209 7.163c5.21 0 5.21 7.162 5.21 7.162M18.876 7.547s0-3.523 2.596-3.523C18.876 4.024 18.876.5 18.876.5s0 3.524-2.597 3.524c2.597 0 2.597 3.523 2.597 3.523"
  })));
};
export default SvgIconSparkles;